import {Action, createReducer, on} from '@ngrx/store';
import {Dictionary, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as fromActions from './statistics-table.actions';
import { TableState, flattenFilters } from '@app/shared/filters/filters-model';
import { Pagination } from '@app/core/models';
import { LinkStatisticsTableModel } from '@app/core/models/newsletter.model';
import { INITIAL_NEWSLETTER_LINK_STATISTICS_FILTERS, NewsletterLinkStatisticsTableFilters } from '@app/shared/filters/models/newsletter-link-statistics';


export interface Sugg {
  name: string;
  tickersMessage: string[];
}

export const adapter: EntityAdapter<LinkStatisticsTableModel> =
 createEntityAdapter<LinkStatisticsTableModel>({
  selectId: (e) => e.id
 });
 
export interface State {
  table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>;
}

export const initialState: State = {
  table: {
    data: adapter.getInitialState(),
    pagination: {
      ...Pagination,
      pageIndex: 0,
      pageSize: 10,
    },
    sort: {
      active: 'name',
      direction: 'asc'
    },
    defaultSort: {
      active: 'name',
      direction: 'asc'
    },
    filters: INITIAL_NEWSLETTER_LINK_STATISTICS_FILTERS,
    defaultFilters: INITIAL_NEWSLETTER_LINK_STATISTICS_FILTERS,
    isLoading: false,
    resetIndex: false,
  },
};

const contentPageReducer = createReducer(
  initialState,
  on(fromActions.table.request, (state) => ({
    ...state,
    table: {
      ...state.table,
      isLoading: true
    }
  })),
  on(fromActions.table.success, fromActions.table.failure, (state) => ({
    ...state,
    table: {
      ...state.table,
      isLoading: false
    }
  })),
  on(fromActions.table.setAllLinks, (state, {data}) => ({
    ...state,
    table: {
      ...state.table,
      data: adapter.setAll(data, state.table.data),
      resetIndex: false,
    }
  })),
  on(fromActions.table.success, (state, {data, pagination}) => ({
    ...state,
    table: {
      ...state.table,
      data: adapter.setAll(data, state.table.data),
      pagination,
      resetIndex: false,
    }
  })),
  on(fromActions.table.filter, (state, {filters}) => ({
    ...state,
    table: {
      ...state.table,
      filters,
      resetIndex: true
    }
  })),
  on(fromActions.table.sort, (state, {active, direction}) => ({
    ...state,
    table: {
      ...state.table,
      sort: {
        active,
        direction
      }
    }
  })),
  on(fromActions.table.paginate, (state, {pageIndex, pageSize}) => ({
    ...state,
    table: {
      ...state.table,
      pagination: {
        ...state.table.pagination,
        pageIndex,
        pageSize
      }
    }
  })),
  on(fromActions.table.clear, (state) => ({
    ...initialState
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return contentPageReducer(state, action);
}

// NEW WAY TABLE
export const getTableState = (state: State) => state.table;

export const getPagination = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => table.pagination;
export const getSort = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => table.sort;
export const getDefaultSort = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => table.defaultSort;
export const getFilters = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => table.filters;
export const getDefaultFilters = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => table.defaultFilters;
export const getIsLoading = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => table.isLoading;

export const getRequestData = ({pagination, sort, filters, resetIndex}: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => ({
  pageIndex: pagination.pageIndex,
  pageSize: pagination.pageSize,
  sort,
  filters: flattenFilters(filters),
  resetIndex
});

export const getTableData = (table: TableState<LinkStatisticsTableModel, NewsletterLinkStatisticsTableFilters>) => adapter.getSelectors().selectAll(table.data);

// Pagination fields
export const getPageSize = (pagination: Pagination) => pagination.pageSize;
export const getPageIndex = (pagination: Pagination) => pagination.pageIndex;
export const getTotalCount = (pagination: Pagination) => pagination.totalCount;

// Filters fields
export const getSearch = (filters: NewsletterLinkStatisticsTableFilters) => filters.search.value;

export const getEntitiesByIds = (entities: Dictionary<LinkStatisticsTableModel>, ids: string[]): LinkStatisticsTableModel[] => ids.map(id => entities[id]);